import Model from '@/models/Model'

export default class HrAssetDiscount extends Model {
    //
    static includes = ['hr_asset_discount_type']

    /**
     *
     */
    get hr_asset_discount_type_name() {
        return this.hr_asset_discount_type.type
    }

    /**
     *
     */
    resource() {
        return 'hr_asset_discount'
    }

    /**
     *
     */
    toCreate() {
        //
        return this.clean(['name', 'hr_asset_discount_type_id'])
    }

    /**
     *
     */
    toUpdate() {
        //
        return this.clean(['id', 'name', 'hr_asset_discount_type_id'])
    }
}
